import { type HistoryGroup } from "@/features/history/utils";
import { mapIdsToNames } from "@/utils/mapIdsToNames";
import { type History } from "@repo/api";
import { Text } from "@repo/skapa";
import { t } from "@repo/translation";
import { translateKey, translateServices, useOrderedServices } from "@repo/ui";

import { HistoryListViewItem } from "./HistoryListViewItem";

interface InterestedServicesHistoryItemProps {
  history: History | HistoryGroup;
}

const parseToNumberArray = (newValue: unknown): number[] => {
  if (typeof newValue === "string") {
    return newValue.split(",").map(Number);
  }
  return typeof newValue === "number" ? [newValue] : [];
};

export const InterestedServicesHistoryItem = ({
  history,
}: InterestedServicesHistoryItemProps) => {
  const services = useOrderedServices();
  const newValueArray = parseToNumberArray(history.details?.new_value);
  const items = mapIdsToNames(newValueArray, services)
    ?.map((item) => translateServices(item as string))
    .join(", ");

  return (
    <HistoryListViewItem
      history={history}
      control="default"
      title={translateKey(history.title) ?? ""}
      description={
        <Text textStyle="Body.S">
          {t("label.services_interested")}:
          {items || t("prompt.deselected_all_services")}
        </Text>
      }
    />
  );
};
